/* eslint-disable no-use-before-define */

import React from "react";
import { Text, View, StyleSheet } from "react-native";
import MenuButton from ".//MenuButton";
import Icon from "react-native-vector-icons/FontAwesome";
import { RepositColours } from "../utils/styles";
import { browserHistory } from "react-router";

const ChevLeft = (
  <Icon
    name="chevron-left"
    size={26}
    color={RepositColours.blue}
    style={{ fontWeight: "300" }}
  />
);

const WebHeading = ({ title, left, right }) => {
  return (
    <View style={styles.heading}>
      <View style={{ marginTop: 15, marginBottom: 5, flexDirection: "row" }}>
        {title !== "Home" ? (
          <Text
            style={{ marginLeft: 20, fontSize: 26 }}
            onPress={() => browserHistory.goBack()}
          >
            {left || ChevLeft}
          </Text>
        ) : (
          <Text style={{ marginLeft: 20, fontSize: 26 }}> </Text>
        )}
        <Text style={{ flex: 1, textAlign: "center", marginTop: 5 }}>
          {title}
        </Text>
        <Text style={{ textAlign: "right", marginBottom: 10 }}>
          {right || <MenuButton />}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  heading: {
    borderBottomColor: "#E2E2E2",
    borderBottomWidth: 1,
    justifyContent: "center",
    backgroundColor: "#FAFAFA",
  },
});

export default WebHeading;



// WEBPACK FOOTER //
// ./src/components/WebHeading.web.js